import moment from "moment";
import httpClient from "@/store/httpClient";

/*
function parseTimestamp(input) {
    return moment(parseInt(input)).format("DD.MM.YYYY");
}
*/

export default {
    namespaced: true,
    state: {
        contracts: []
    },
    mutations: {
        SET_CONTRACTS(state, contracts) {
            state.contracts = contracts;
        }
    },
    actions: {
        async loadContracts({ commit }) {
            const response = await httpClient("/enaio");

            if (response.status !== 200) return;

            await commit("SET_CONTRACTS", response.data);
        },
    },
    getters: {
        getContracts(state) {
            const now = moment();
            const contracts = state.contracts.map((item) => {
                Object.keys(item.simpleFields).forEach((key) => {
                    let newKey = key.replaceAll(" ", "_").replaceAll(".", "");
                    if (key !== newKey) {
                        item.simpleFields[newKey] = item.simpleFields[key];
                        delete item.simpleFields[key];
                    }
                });
                const end = moment(parseInt(item.simpleFields.Vertragsende));
                const Restlaufzeit = end.diff(now, "years", true).toFixed(1);

                const termine = item.tableFields["Manuell gesetzte Termine"].filter(t => t.Terminart === "Sonderkündigung");



                const data = {
                    osId: item.osId,
                    link: item.link,
                    ...item.simpleFields,
                    termine,
                    Restlaufzeit: Restlaufzeit < "0" ? "0" : Restlaufzeit,
                };

                return data;
            });

            return contracts.filter(c => c.Vertragsstatus === 'aktiv' || c.Vertragsstatus === 'nicht aktiv');
        },
        getActiveContractsCount(state) {
            return state.contracts.filter(
                (contract) => contract.simpleFields["Vertragsstatus"] === "aktiv"
            ).length;
        },
        getInactiveContractsCount(state) {
            return state.contracts.filter(
                (contract) => contract.simpleFields["Vertragsstatus"] !== "aktiv"
            ).length;
        },
        getContractStates(state) {
            return [
                ...new Set(state.contracts.map((c) => c.simpleFields["Vertragsstatus"])),
            ];
        },
        maxSonderkuendigungstermine(state) {
            const termine = state.contracts.map(c => c.tableFields["Manuell gesetzte Termine"].filter(t => t.Terminart === "Sonderkündigung").length);

            return Math.max(...termine);
        }
    }
}
